import React from 'react';
import { Column, Row } from '../../../../../../shared/components/Grid/Grid';
import number from '../../../../../../shared/util/utilities/number';
import { t } from '../../../../../../shared/components/l10n/l10n';
import ExternalLink from '../../../../../../shared/components/ExternalLink';
import { MoneyflowOfferOverviewResult } from '../../../../../../../types/internal-api';

interface Props {
    showAgreementLink: boolean;
    data: MoneyflowOfferOverviewResult;
}

export default function MoneyflowOfferDetails({ showAgreementLink, data }: Props) {
    const { agreementUrl, invoiceAmount, offerFee, offerVat, offerAmount, offerFeeBeforeDiscount, offerFeeDiscountPercentage } =
        data;
    return (
        <div>
            <Row>
                <Column>
                    <h3 className="moneyflow__amount__title">{t`FORM_BOOKANDSEND_MONEYFLOW_PAYMENTOVERVIEW`}</h3>
                </Column>
                {showAgreementLink && (
                    <Column>
                        <div className="moneyflow__amount__view-agreement">
                            <ExternalLink href={agreementUrl}>{t`FORM_BOOKANDSEND_MONEYFLOW_VIEWAGREEMENT`}</ExternalLink>
                        </div>
                    </Column>
                )}
            </Row>

            <Row>
                <Column>
                    <div className="moneyflow__amount-text">{t`FORM_BOOKANDSEND_MONEYFLOW_NET_AMOUNT`}:</div>
                </Column>
                <Column>
                    <div className="moneyflow__amount-value">{number.format(invoiceAmount)} DKK</div>
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="moneyflow__amount-text">{t`FORM_BOOKANDSEND_MONEYFLOW_FEE`}:</div>
                </Column>
                <Column>
                    <div className="moneyflow__amount-value">{number.format(offerFeeBeforeDiscount)} DKK</div>
                </Column>
            </Row>
            {offerFeeDiscountPercentage !== 0 && (
                <Row>
                    <Column>
                        <div className="moneyflow__amount-text">
                            {t('FORM_BOOKANDSEND_MONEYFLOW_FEE_DISCOUNT', { DISCOUNT: offerFeeDiscountPercentage })}:
                        </div>
                    </Column>
                    <Column>
                        <div className="moneyflow__amount-value">-{number.format(offerFeeBeforeDiscount - offerFee)} DKK</div>
                    </Column>
                </Row>
            )}
            <Row>
                <Column>
                    <div className="moneyflow__amount-text">{t`FORM_BOOKANDSEND_MONEYFLOW_VAT`}:</div>
                </Column>
                <Column>
                    <div className="moneyflow__amount-value">{number.format(offerVat)} DKK</div>
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="moneyflow__sum-line" />
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="moneyflow__amount__total-text">{t`FORM_BOOKANDSEND_MONEYFLOW_AMOUNT_RECEIVED`}:</div>
                </Column>
                <Column>
                    <div className="moneyflow__amount__total-value">{number.format(offerAmount)} DKK</div>
                </Column>
            </Row>
        </div>
    );
}
